import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Toast.css';
import { TOAST_Z_INDEX } from './toast';

const Toast = () => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted || typeof document === 'undefined') {
    return null;
  }

  return createPortal(
    <ToastContainer
      theme="dark"
      style={{ zIndex: TOAST_Z_INDEX }}
      containerClassName="app-toast-container"
      position="top-right"
      newestOnTop
    />,
    document.body
  );
};

export default Toast;
